<ul style="margin: -16px">
  <li *ngFor="let item of boxInfoAlertService.alertRouter, let i = index" class="card-alerta">
    <p class="titulo mb-0"> {{ item.Motivo }} - {{ item.CodigoOcorrencia }} </p>
    <p class="sub-titulo"> {{ item.Data.replace('Z', '') | date: 'dd/MM/yyyy' }} às {{ item.Data.replace('Z', '') | date: 'hh:MM' }} </p>

    <div class="d-flex justify-content-between m-0">
      <div >
        <app-status-roteiro [mensagem]="item.dadosStatus.msg" [color]="item.dadosStatus.cor" [caminho]="item.dadosStatus.caminho"></app-status-roteiro>
      </div>
      <div class="pe-2">
        <button class="btn-clean" data-tooltip="Visualizar mensagem" data-tooltip-pos="top" (click)="openModalMsgOc(item)"><img src="assets/img/icons/chat-right-text.svg" alt=""></button>
        <button class="btn-clean hide-on-mobile" data-tooltip="Ir para ocorrência" data-tooltip-pos="top" (click)="abrirOcorrencia(item)"><img src="assets/img/icons/box-arrow-up-right.svg" alt=""></button>
      </div>
    </div>

  </li>
</ul>

<app-popup-msg-oc
  *ngIf="boxInfoAlertService.abrirModalMensagemOc"
  [mensagem]="boxInfoAlertService.mensagemModal"
  [data]="boxInfoAlertService.dataModal">
</app-popup-msg-oc>
